module.exports = __webpack_public_path__ + "static/media/Nicolas-profile.a423b1fa.jpg";